module.exports = __webpack_public_path__ + "static/media/NICE_Step2a_Image23.e704036e.jpg";